'use client';

/**
 * Retrieves the global `window` object if it's defined, typically in a browser environment.
 * Returns `undefined` in environments where `window` is not defined, such as server-side rendering.
 * This function is useful for ensuring compatibility with server-side rendering by
 * avoiding direct references to the `window` object which is not available in Node.js environments.
 *
 * @returns {(Window | undefined)} The global `window` object if available, otherwise `undefined`.
 *
 * @example
 * const currentWindow = getWindow();
 * if (currentWindow) {
 *   console.log('Running in a browser environment');
 * } else {
 *   console.log('Running in a server-side or non-browser environment');
 * }
 */
export const getWindow = () => {
  return typeof window !== 'undefined' ? window : undefined;
};
